import { IRestaurant } from '@rbi-ctg/store';
import { ServiceMode } from 'generated/graphql-gateway';

import {
  ICreateCartEntryParams,
  ILegacyCartEntry,
  IUseInRestaurantCart,
} from './hooks/use-in-restaurant-redemption-cart';
import { ShortCodePollingStatus } from './hooks/use-short-code-poll-status/types';
import { IUserShortCode, ShortCodeState } from './hooks/use-short-code/types';

export { ShortCodeState } from './hooks/use-short-code/types';
export type {
  ILegacyCartEntry,
  ICart,
  ICartEntryDetailsOffer,
  ICartEntryDetailsReward,
  ICartEntryDetails,
} from './hooks/use-in-restaurant-redemption-cart/types';
export { ICartEntryType } from './hooks/use-in-restaurant-redemption-cart/types';

export interface InRestaurantRedemptionFlagsState {
  inRestaurantLoyaltyEnabledAtRestaurantLoading: boolean;
  inRestaurantLoyaltyEnabledAtRestaurant: boolean;
}

export interface IInRestaurantRedemptionContext
  extends Pick<IUserShortCode, 'shortCode' | 'shortCodeState' | 'shortCodeLoading'> {
  inRestaurantLoyaltyEnabledAtRestaurant: boolean;
  inRestaurantLoyaltyEnabledAtRestaurantLoading: boolean;
  inRestaurantRedemptionEnabled: boolean;
  isQuickPayEnabled: boolean;
  setIsQuickPayEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  shouldResetPollingResultStatus: boolean;
  setShouldResetPollingResultStatus: React.Dispatch<React.SetStateAction<boolean>>;
  pollingShortCodeStatus: ShortCodePollingStatus;
  setPollingShortCodeStatus: React.Dispatch<React.SetStateAction<ShortCodePollingStatus>>;
  shortCodeLoading: boolean;
  shortCodeState: ShortCodeState;
  shortCode: string | undefined;
  generateShortCode: () => void;
  setShortCodeClaimed: () => void;
  setShortCodeExpired: () => void;
  resetInRestaurantRedemption: () => void;
  addInRestaurantRedemptionEntry: (item: ICreateCartEntryParams) => void;
  inRestaurantRedemptionCart: IUseInRestaurantCart['inRestaurantCart'];
  isInRestaurantRedemptionCartEmpty: boolean;
  removeInRestaurantRedemptionEntry: (cartEntry: ILegacyCartEntry) => void;
  updateInRestaurantRedemptionEntryQuantity(cartEntry: ILegacyCartEntry, quantity: number): void;
  existEntryTypeInRestaurantRedemptionCart: IUseInRestaurantCart['existEntryTypeInRestaurantCart'];
  clearInRestaurantRedemptionAllRewards: IUseInRestaurantCart['clearInRestaurantCartAllRewards'];
  isInRestaurantRedemptionEnabledAtStore: (
    store: IRestaurant,
    serviceMode?: ServiceMode | null
  ) => Promise<boolean>;
  enableOfferRedemption: boolean;
  enableRewardRedemption: boolean;
  scanSucceeded: boolean;
  setScanSuccess: (success: boolean) => void;
  shouldForceRestaurantSelection: boolean;
  canRedeemLoyaltyIncentives: boolean;
}

export interface IInRestaurantFlagVariations {
  enableOfferRedemption: boolean;
  enableRewardRedemption: boolean;
}

export type IsServiceModeValid = (params: { serviceMode: ServiceMode | null }) => boolean;

export interface IsRedemptionOnCurrentDevice {
  isMobile: boolean;
}
